import { HOW_AMDEN_WORKS } from '@/data/services';
import { Reveal } from '../Reveal';

// Section 6 — How Amden works. Same four-stage visual language as the
// approved process sections elsewhere on the site.
export const HowAmdenWorks = () => (
  <section aria-labelledby="how-amden-heading" data-testid="how-amden-works" className="bg-white py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <p className="flex items-center gap-3">
          <span className="font-mono text-xs font-medium tracking-widest text-gold-700">06</span>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">
            {HOW_AMDEN_WORKS.eyebrow}
          </span>
        </p>
        <h2 id="how-amden-heading" data-testid="how-amden-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
          {HOW_AMDEN_WORKS.heading}
        </h2>
      </div>

      <ol className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {HOW_AMDEN_WORKS.stages.map((s, i) => (
          <li key={s.step}>
            <Reveal delay={i * 0.08} className="h-full">
              <div className="flex h-full flex-col rounded-xl border border-slate-200 bg-mist p-7" data-testid={`how-stage-${s.step}`}>
                <span className="font-mono text-2xl font-medium text-gold-700" aria-hidden="true">
                  {s.step}
                </span>
                <h3 className="mt-4 text-lg font-extrabold tracking-tight text-navy-900">{s.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{s.copy}</p>
              </div>
            </Reveal>
          </li>
        ))}
      </ol>

      <Reveal delay={0.1}>
        <p className="mx-auto mt-10 max-w-3xl border-l-2 border-gold-500 pl-5 text-base font-medium italic leading-relaxed text-navy-800 sm:text-lg" data-testid="how-amden-statement">
          {HOW_AMDEN_WORKS.statement}
        </p>
      </Reveal>
    </div>
  </section>
);
